import { useAuth } from '../context/AuthContext';
import LeafLogo from './LeafLogo';
import styles from './Sidebar.module.css';

// ─── Nav config per role ───────────────────────────────────────
// Each role only sees its own permitted modules (per the paper)
const NAV_CONFIG = {
  admin: [
    { key: 'orders',        label: 'Orders',      icon: 'ti-shopping-cart' },
    { key: 'transactions',  label: 'Transact',    icon: 'ti-credit-card'   },
    { key: 'tracking',      label: 'Tracking',    icon: 'ti-truck'         },
    { key: 'inventory',     label: 'Inventory',   icon: 'ti-package'       },
    { key: 'archives',      label: 'Archives',    icon: 'ti-archive'       },
    { key: 'maintenance',   label: 'Maintain',    icon: 'ti-tool'          },
    { key: 'registration',  label: 'Register',    icon: 'ti-user-plus'     },
    { key: 'reports',       label: 'Reports',     icon: 'ti-chart-bar'     },
    { key: 'help',          label: 'Help',        icon: 'ti-help-circle'   },
  ],
  supplier: [
    { key: 'inventory',     label: 'Inventory',   icon: 'ti-package'       },
    { key: 'tracking',      label: 'Tracking',    icon: 'ti-truck'         },
    { key: 'reports',       label: 'Reports',     icon: 'ti-chart-bar'     },
    { key: 'help',          label: 'Help',        icon: 'ti-help-circle'   },
  ],
  branch: [
    { key: 'orders',         label: 'Orders',      icon: 'ti-shopping-cart' },
    { key: 'transactions',   label: 'Payment',     icon: 'ti-credit-card'   },
    { key: 'tracking',       label: 'Track',       icon: 'ti-truck'         },
    { key: 'weeklyProfits',  label: 'Profits',     icon: 'ti-chart-line'    },
    { key: 'help',           label: 'Help',        icon: 'ti-help-circle'   },
  ],
};

export default function Sidebar({ activePage, onNavigate }) {
  const { user, logout } = useAuth();
  const navItems = NAV_CONFIG[user?.role] || [];

  function handleLogout() {
    if (window.confirm('Are you sure you want to sign out?')) {
      logout();
    }
  }

  return (
    <aside className={styles.sidebar}>
      {/* Logo */}
      <button className={styles.logoBtn} onClick={() => onNavigate('dashboard')} aria-label="Go to home">
        <div className={styles.logoCircle}>
          <LeafLogo size={48} color="#FFFFFF" bgColor="#7B3F1E" />
        </div>
        <p className={styles.brandText}>Juan<br />Café</p>
      </button>

      {/* Nav Items */}
      <nav className={styles.nav} aria-label="Main navigation">
        {navItems.map((item) => (
          <button
            key={item.key}
            className={`${styles.navItem} ${activePage === item.key ? styles.navItemActive : ''}`}
            onClick={() => onNavigate(item.key)}
            title={item.label}
            aria-current={activePage === item.key ? 'page' : undefined}
          >
            <i className={`ti ${item.icon} ${styles.navIcon}`} aria-hidden="true" />
            <span className={styles.navLabel}>{item.label}</span>
          </button>
        ))}
      </nav>

      {/* Footer: user avatar + logout */}
      <div className={styles.footer}>
        <div
          className={styles.avatar}
          title={`Signed in as ${user?.name}`}
          aria-label={`User: ${user?.name}`}
        >
          {user?.initials}
        </div>
        <button
          className={styles.logoutBtn}
          onClick={handleLogout}
          title="Sign out"
          aria-label="Sign out"
        >
          <i className="ti ti-logout" aria-hidden="true" />
        </button>
      </div>
    </aside>
  );
}
